var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSharpStar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:sharp-star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 28.7833L30.3 35L27.5667 23.2833L36.6667 15.4L24.6833 14.3833L20 3.33334L15.3167 14.3833L3.33333 15.4L12.4333 23.2833L9.7 35L20 28.7833Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharpStar1);
export default __webpack_public_path__ + "static/media/ic_sharp-star (1).1cc13d30443bc8e5f20b0bd8c6b33d18.svg";
export { ForwardRef as ReactComponent };